module.exports = __webpack_public_path__ + "img/40@2x.bea76893.png";